export default __webpack_public_path__ + "static/media/aff.a3663c3e.webp";